import React from 'react';
import ProcesosComponent from './Procesos';

const Procesos = () => {

    //validations
    

    return (
        <div>
            <ProcesosComponent />
        </div>
    );
};

export default Procesos;